module.exports = __webpack_public_path__ + "img/websocket.35d1c533.svg";